import React, { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { BASE_URL, GET_ALL_TEST, SEND_DIAGNOSTICS } from "../../API";
import { ProfileContext } from "../../context/ProfileContext";

const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        border: state.isFocused ? '1px solid #0195F74D' : '1px solid #0195F74D',
        boxShadow: 'none',
        fontSize: '14px',
        '&:hover': { borderColor: '#0195F74D' }
    }),

    valueContainer: (provided) => ({ ...provided, fontSize: '14px' }),
    multiValue: (provided) => ({ ...provided, fontSize: '13px' }),
    multiValueLabel: (provided) => ({ ...provided, fontSize: '13px' }),
    menu: (provided) => ({ ...provided, fontSize: '14px' })
};


function ReferralForm({ referral }) {
    const navigate = useNavigate();
    const [diagnosticsTest, setDiagnosticsTest] = useState([])
    const { headers, getRefferal, diagnosticsCenter } = useContext(ProfileContext)
    const { register, handleSubmit, formState: { errors }, control, setValue, clearErrors, } = useForm();
    useEffect(() => { getAllTests(); }, [])

    const getAllTests = async () => {
        try {
            const response = await axios.get(BASE_URL + GET_ALL_TEST, { headers });
            const json = response.data;
            if (json.code === 200 && json.status === true) { setDiagnosticsTest(json?.data?.data) }
            else { console.log("Error fetching products"); }
        }
        catch (err) { console.error("Best season product fetch error:", err); }
    };
    const onSubmit = async (payload) => {
        payload._id = referral?._id;
        payload.language = "ENGLISH";
        payload.specific_tests = payload.specific_tests.map(test => test.value);

        try {
            const res = await axios.post(BASE_URL + SEND_DIAGNOSTICS, payload, { headers });
            if (res.status === 200) {
                toast.success("Referral sent successfully!");
                getRefferal()
                navigate('/referral-management');
            }
        }
        catch (error) {
            const err = error.response?.data?.error_message || error.response?.data?.error_description || "An error occurred.";
            toast.error(err);
        }
    };

    const testOptions = diagnosticsTest.map(test => ({
        value: test.test_name,
        label: test.test_name,
    }));

    return (
        <div className="patient_referral_form">
            <h5 className="comm_inner_sub_heading">Referral Form:</h5>
            <div className="comm_border_box">
                <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Patient Name</Form.Label>
                                <Form.Control type="text" placeholder="Enter Name"
                                    {...register("patient_name", {
                                        required: "Please enter patient name.",
                                        validate: (value) => value.trim() !== "" || "Patient Name cannot be empty or just spaces.",
                                    })}
                                    defaultValue={referral?.userData?.full_name || ""}
                                />
                                {errors.patient_name && (<span className="error">{errors.patient_name.message}</span>)}
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Age</Form.Label>
                                <Form.Control type="number" placeholder="Enter age" {...register("age", { required: "Please enter patient age.", })}
                                    defaultValue={referral?.age || ""}
                                />
                                {errors.age && (<span className="error">{errors.age.message}</span>)}
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Gender</Form.Label>
                                <Form.Select {...register("gender", { required: "Please select gender." })} defaultValue={referral?.gender || ""}>
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="others">Others</option>
                                </Form.Select>
                                {errors.gender && <span className="error">{errors.gender.message}</span>}
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Date of Birth</Form.Label>
                                <Form.Control
                                    type="date"
                                    {...register("dateOfBirth", {
                                        required: "Please select DOB.",
                                        validate: (value) => {
                                            const selected = new Date(value);
                                            const now = new Date();
                                            selected.setHours(0, 0, 0, 0);
                                            now.setHours(0, 0, 0, 0);
                                            return selected < now || "Date of birth cannot be today or in the future.";
                                        },
                                    })}
                                    onChange={(e) => {
                                        setValue("dateOfBirth", e.target.value);
                                        clearErrors("dateOfBirth");
                                    }}
                                    onClick={(e) => e.target.showPicker()}
                                    defaultValue={referral?.userData?.dob}
                                />
                                {errors.dateOfBirth && (<span className="error">{errors.dateOfBirth.message}</span>)}
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Diagnosis</Form.Label>
                                <Form.Control type="text" placeholder="Enter Diagnosis"
                                    defaultValue={referral?.diagnostic_data?.medicalDiagnosis || ""}
                                    {...register("diagnosis", {
                                        required: "Please enter diagnosis.",
                                        validate: (value) => value.trim() !== "" || "Diagnosis cannot be empty or just spaces.",
                                    })}
                                />
                                {errors.diagnosis && (<span className="error">{errors.diagnosis.message}</span>)}
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Department (Diagnostic Center)</Form.Label>
                                <Form.Select {...register("department", { required: "Please select department." })}>
                                    <option value="">Select Diagnostic Center</option>
                                    {diagnosticsCenter.map((center) => (<option key={center._id} value={center._id}>{center.center_name || center.name}</option>))}
                                </Form.Select>
                                {errors.department && (<span className="error">{errors.department.message}</span>)}
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Preferred Appointment Date</Form.Label>
                                <Form.Control type="date"
                                    {...register("appointmentDate", { required: "Please select appointment date.", })}
                                    onChange={(e) => { setValue("appointmentDate", e.target.value); clearErrors("appointmentDate"); }}
                                    onClick={(e) => e.target.showPicker()}
                                />
                                {errors.appointmentDate && (<span className="error">{errors.appointmentDate.message}</span>)}
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Specific Tests Required</Form.Label>

                                <Controller
                                    name="specific_tests"
                                    control={control}
                                    rules={{ validate: value => value && value.length > 0 || "Please select at least one test." }}
                                    render={({ field }) => (
                                        <Select
                                            styles={customSelectStyles}
                                            classNamePrefix="react-select test_multiselect"
                                            {...field}
                                            options={testOptions}
                                            isMulti
                                            placeholder="Select tests..."
                                            onChange={(selected) => field.onChange(selected)}
                                        />
                                    )}
                                />

                                {errors.specific_tests && (
                                    <span className="error">{errors.specific_tests.message}</span>
                                )}
                            </Form.Group>
                        </Col>


                        {/* <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Specific Test Required</Form.Label>
                                <Form.Select {...register("Specific_test_required", { required: "Please select specific test.", })}>
                                    <option value="">Select Specific Test Required</option>
                                    {diagnosticsTest.map((test) => (<option key={test._id} value={test.test_name}>{test.test_name}</option>))}
                                </Form.Select>
                                {errors.Specific_test_required && (<span className="error">{errors.Specific_test_required.message}</span>)}
                            </Form.Group>
                        </Col> */}

                        <Col md={12}>
                            <Form.Group className="comn-class-inputs">
                                <Form.Label>Patient Instructions</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Enter Patient’s Instructions"
                                    {...register("instruction", {
                                        required: "Please provide patient instructions.",
                                        validate: (value) => value.trim() !== "" || "Patient instruction cannot be empty.",
                                    })}
                                />
                                {errors.instruction && (
                                    <span className="error">{errors.instruction.message}</span>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="modal_pair_btns patient_referral_btns mt-3">
                        <button className="main-btn" type="submit">Submit</button>
                        <button type="button" className="main-outline-btn" onClick={() => navigate("/referral-management")}>Discard Changes</button>
                    </div>
                </Form>
            </div>
        </div >
    );
}

export default ReferralForm;
